import { Controller } from "@hotwired/stimulus"
import { auto } from "@popperjs/core"

export default class extends Controller {
  connect() {
    console.log("Year select controller connected!")

    if (!this.element) {
      console.error("Element not found for year-select controller")
      return
    }

    this.initializeSelect2()
  }

  initializeSelect2() {
    if (typeof $ !== "undefined" && $.fn.select2) {

      
      if ($(this.element).hasClass("select2-hidden-accessible")) {
        $(this.element).select2("destroy")
      }

      $(this.element).select2({
        width: "240px",
        minimumResultsForSearch: Infinity,
        dropdownCssClass: "custom-year-dropdown" 
      })

      
      const selection = $(this.element)
        .next(".select2-container")
        .find(".select2-selection")

      selection.addClass(
        "form-control ps-12 d-flex align-items-center"
      )

     
      selection.css({
        height: 42,
        border: "1px solid #E4E6EF",
        borderRadius: "0.5rem"
      })

     
      $(this.element)
        .next(".select2-container")
        .find(".select2-selection__rendered")
        .css({
          lineHeight: "48px",
          paddingLeft: "0"
        })

    
      $(this.element)
      .next(".select2-container")
      .find(".select2-selection__arrow")
      .hide()

      
      $(this.element).on("select2:select", (e) => {
        this.onYearChange(e)
      })

    } else {

      this.element.addEventListener("change", (e) => {
        this.onYearChange(e)
      })
    }
  }

  onYearChange(event) {
    let year

    if (event.params && event.params.data) {
      year = event.params.data.id
    } else {
      year = event.target.value
    }

    if (!year) return

    const url = new URL(window.location.href)

    url.searchParams.set("year", year)
    url.searchParams.set("mode", "yearly")
    url.searchParams.delete("month")
    url.searchParams.set("page", "1")

    Turbo.visit(url.toString(), {
      frame: "table_body"
    })
  }

  disconnect() {
    if (
      typeof $ !== "undefined" &&
      $.fn.select2 &&
      $(this.element).hasClass("select2-hidden-accessible")
    ) {
      $(this.element).select2("destroy")
    }
  }
}